<template>
  <section class="step-container">
    <header class="step-container__header">
      <h2 v-if="title">
        {{ title }}
        <Hint v-if="hint" :message="hint" />
      </h2>

      <p
        v-if="description"
        v-dompurify-html="description"
        class="step-container__description"
      />
    </header>

    <div class="step-container__content">
      <slot />
    </div>

    <div class="step-container__actions">
      <slot name="actions" />
    </div>
  </section>
</template>

<script>
import Hint from '@@/common/Hint';

export default {
  name: 'StepContainer',
  components: { Hint },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.step-container {
  width: 100%;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  &__header {
    margin-bottom: $global-margin;
  }

  &__description {
    font-size: 95%;
    color: $lb-darker-gray;
  }

  &__content {
    flex-grow: 1;
  }

  &__actions {
    border-top: 2px dashed #dfdfdf;
    padding-top: 2 * $global-margin;
    margin-top: 2 * $global-margin;
  }
}
</style>
